// SupportedIntegrations.tsx
import React, { useState } from 'react';
import {
  Box,
  Stack,
  Chip,
  Tooltip,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
  Typography,
} from '@mui/material';
import { WebhookProvider, WEBHOOK_PROVIDERS } from './IntegrationTypes';

const SupportedIntegrations = () => {
  const [formState, setFormState] = useState({
    selectedProvider: null as WebhookProvider | null,
    howToDialogOpen: false,
  });

  const handleClose = () => {
    setFormState((prev) => ({ ...prev, howToDialogOpen: false }));
  };

  const handleChipClick = (provider: WebhookProvider) => {
    setFormState({
      selectedProvider: provider,
      howToDialogOpen: true,
    });
  };

  return (
    <>
      <Stack direction="row" spacing={1} flexWrap="wrap" useFlexGap gap={1}>
        {WEBHOOK_PROVIDERS.map((provider) => (
          <Tooltip
            key={provider.id}
            title={`Click to see ${provider.name} setup instructions`}
          >
            <Chip
              icon={
                provider.logoPath ? (
                  <Box
                    component="img"
                    src={provider.logoPath}
                    sx={{ width: 20, height: 20 }}
                    alt={provider.name}
                  />
                ) : undefined
              }
              label={provider.name}
              variant="outlined"
              onClick={() => handleChipClick(provider.id)}
              sx={{
                borderColor: 'secondary.main',
                '&:hover': {
                  borderColor: 'primary.main',
                  cursor: 'pointer',
                  bgcolor: 'action.hover',
                },
              }}
            />
          </Tooltip>
        ))}
      </Stack>

      {/* Dialog for How-To Instructions */}
      <Dialog
        open={formState.howToDialogOpen}
        onClose={handleClose}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle>
          {
            WEBHOOK_PROVIDERS.find((p) => p.id === formState.selectedProvider)
              ?.name
          }{' '}
          Setup Instructions
        </DialogTitle>
        <DialogContent>
          <DialogContentText component="div">
            {WEBHOOK_PROVIDERS.find(
              (p) => p.id === formState.selectedProvider
            )?.howToDirections?.map((direction, index) => (
              <Typography key={index} paragraph>
                {direction}
              </Typography>
            ))}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} variant="contained">
            Close
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default SupportedIntegrations;
